/** `C/d.txt` -> `C`; `d.txt` -> `''`. */
export const folderPartOf = (relativePath: string): string => {
  const slash = relativePath.lastIndexOf('/');
  return slash === -1 ? '' : relativePath.slice(0, slash);
};

/** Keeps the file in its folder. */
export const withRenamedFile = (
  relativePath: string,
  newName: string,
): string => {
  const folder = folderPartOf(relativePath);
  return folder ? `${folder}/${newName}` : newName;
};
